export const polymarketRoutePaths = {
  list: {
    path: 'polymarket',
    fullPath: '/polymarket',
  },
  detail: {
    path: 'polymarket/:marketId',
    fullPath: (marketId: string) => `/polymarket/${marketId}`,
  },
  /** @deprecated 하위호환용. 신규 코드는 `my` 사용 */
  me: {
    path: 'polymarket/me',
    fullPath: '/polymarket/me',
  },
  my: {
    path: 'polymarket/my',
    fullPath: '/polymarket/my',
  },
  leaderboard: {
    path: 'polymarket/leaderboard',
    fullPath: '/polymarket/leaderboard',
  },
  propose: {
    path: 'polymarket/propose',
    fullPath: '/polymarket/propose',
  },
};
